module.exports = __webpack_public_path__ + "static/media/truckBanner.b42d7ac2.jpg";